import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LoadingController, NavController, Platform } from '@ionic/angular';
import { UserData } from './services/user-data/user-data';
import { GlobalService } from './services/global.service/global.service';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { PushNotifications } from '@capacitor/push-notifications';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  providers: [GlobalService],
})

export class AppComponent implements OnInit {
  dark: any;
  showCookieBanner = false;
  showCookieManage = false;
  showNotificationPrompt = false;
  showGooglePrompt = false;
  googleLoading = false;
  cookieChoices = {
    analytics: false,
    personalization: false,
    marketing: false
  };

  constructor(
    private platform: Platform,
    public userData: UserData,
    private globalSrvc: GlobalService,
    private paypalRef: ElementRef,
    private storage: Storage,
    private router: Router,
    private loadingCtrl: LoadingController,
    private navCtrl: NavController

  ) {
    this.globalSrvc.darkModeToggleState.subscribe(value => {
      this.dark = value;
      console.log(value);
    });
    this.dark = localStorage.getItem('dark') === 'true' ? true : false;

    /* this.fcm.onNotification().subscribe(data => {

         console.log(data);

        if (data.wasTapped) {

          console.log('Received in background');

        } else {

          console.log('Received in foreground');

        }

      });*/
    this.initializeApp();
  }

  async ngOnInit() {
    await this.storage.create();
    this.configureConsentPrompts();
  }


  initializeApp() {
    //this.authService.init();
    this.platform.ready().then(async () => {
      // ok, what this will do is to as soon as the app is open, it will check for the device language, only if the language was not set before
      // clear? yes so in the if we have to put all languages that i translated right?correct
      const language = this.userData.getSession('language');
      if (language && language.length != 2) {
        this.userData.getDeviceLanguage();
      }
    });
  }

  private configureConsentPrompts() {
    if (!localStorage.getItem('rv_cookie_consent_v1')) {
      this.showCookieBanner = true;
    } else {
      this.restoreCookieChoices();
    }

    if (this.canAskForPush()) {
      setTimeout(() => {
        this.showNotificationPrompt = true;
      }, 900);
    }

    if (!this.userData.isMemberSession() && !localStorage.getItem('rv_google_prompt_dismissed_v1')) {
      setTimeout(() => {
        this.showGooglePrompt = true;
      }, 1400);
    }
  }

  private restoreCookieChoices() {
    try {
      const stored = JSON.parse(localStorage.getItem('rv_cookie_consent_v1') || '{}');
      this.cookieChoices = {
        analytics: !!stored.analytics,
        personalization: !!stored.personalization,
        marketing: !!stored.marketing
      };
    } catch {
      this.cookieChoices = { analytics: false, personalization: false, marketing: false };
    }
  }

  openCookieChoices() {
    this.showCookieManage = true;
  }

  rejectOptionalCookies() {
    this.cookieChoices = { analytics: false, personalization: false, marketing: false };
    this.persistCookieChoices('rejected_optional');
  }

  acceptAllCookies() {
    this.cookieChoices = { analytics: true, personalization: true, marketing: true };
    this.persistCookieChoices('accepted_all');
  }

  saveCookieChoices() {
    this.persistCookieChoices('custom');
  }

  private persistCookieChoices(choice: string) {
    localStorage.setItem('rv_cookie_consent_v1', JSON.stringify({
      choice,
      essential: true,
      analytics: this.cookieChoices.analytics,
      personalization: this.cookieChoices.personalization,
      marketing: this.cookieChoices.marketing,
      savedAt: new Date().toISOString()
    }));
    this.showCookieBanner = false;
    this.showCookieManage = false;
  }

  private canAskForPush(): boolean {
    if (localStorage.getItem('rv_push_permission_v1')) {
      return false;
    }
    return typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'default';
  }

  async acceptPushNotifications() {
    localStorage.setItem('rv_push_permission_v1', 'accepted');
    this.showNotificationPrompt = false;
    try {
      if (this.platform.is('capacitor')) {
        await PushNotifications.requestPermissions();
      } else if ('Notification' in window) {
        await Notification.requestPermission();
      }
    } catch (error) {
      console.warn('Notification permission request failed.', error);
    }
  }

  declinePushNotifications() {
    localStorage.setItem('rv_push_permission_v1', 'declined');
    this.showNotificationPrompt = false;
  }

  shouldShowGooglePrompt(): boolean {
    const url = this.router.url || '';
    const authRoute = url.includes('/login') || url.includes('/signup') || url.includes('/register');
    return this.showGooglePrompt && !this.showCookieBanner && !this.showCookieManage && !this.userData.isMemberSession() && !authRoute;
  }

  dismissGooglePrompt() {
    localStorage.setItem('rv_google_prompt_dismissed_v1', 'true');
    this.showGooglePrompt = false;
  }

  async loginGoogle(idToken: string) {
    if (this.googleLoading || typeof idToken !== 'string' || idToken.split('.').length !== 3) { return; }
    this.googleLoading = true;
    const loader = await this.loadingCtrl.create({
      spinner: 'crescent',
      backdropDismiss: false
    });
    await loader.present();

    try {
      const googleUser = { authentication: { idToken } };
      this.userData.googleLogin(googleUser).subscribe({
        next: (data: any) => {
          loader.dismiss();
          this.googleLoading = false;
          if (data.success) {
            this.userData.setSession('HAS_LOGGED_IN', true);
            this.userData.setUserData(data.userData);
            this.showGooglePrompt = false;
            this.navCtrl.navigateRoot(['home']);
          } else {
            alert(data.error || 'Google sign in failed.');
          }
        },
        error: () => {
          loader.dismiss();
          this.googleLoading = false;
          alert('Check your internet connection and try Google sign in again.');
        }
      });
    } catch {
      loader.dismiss();
      this.googleLoading = false;
    }
  }

}
